export default "__VITE_ASSET__d2b$SuRS__"